module.exports = __webpack_public_path__ + "img/sld_scb_29_t1_b1_green.c58d64fa.svg";